import {
    BlogsPopularFeedPageState,
    BlogsPopularFeedState,
    initialBlogsPopularFeedPageState,
    initialBlogsPopularFeedState,
    queryKey,
} from 'mk2/apps/blogs/containers/BlogsPopularFeed/BlogsPopularFeed.reducers';
import { AppState } from 'mk2/reducers';

export const getBlogsPopularFeedState = (state: AppState): BlogsPopularFeedState => {
    return state.containers.blogs.blogsPopularFeed || initialBlogsPopularFeedState;
};

export const getBlogsPopularFeedSearchState = (state: AppState, query: string): BlogsPopularFeedPageState => {
    const blogsPopularFeedState = getBlogsPopularFeedState(state);

    const key = queryKey(query);

    if (!blogsPopularFeedState.searches[key]) {
        return initialBlogsPopularFeedPageState;
    }

    return blogsPopularFeedState.searches[key];
};
